"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDatabaseClusterSqlMode = void 0;
const getDatabaseClusterSqlMode = ({ httpClient, }) => ({ database_cluster_id, }) => {
    const path = '/databases';
    const url = `${path}/${database_cluster_id}/sql_mode`;
    return httpClient.get(url);
};
exports.getDatabaseClusterSqlMode = getDatabaseClusterSqlMode;
//# sourceMappingURL=get-database-cluster-sql-mode.js.map